// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3j-0";
export var eligibilityCardNotEligible = "_3j-1";